document.addEventListener('DOMContentLoaded', () => {

  var $gallery = new SimpleLightbox('.gallery a', {});

  // Start Trim Selector JS
  jQuery('.trim-selector__container').not('.slick-initialized').slick({
    "prevArrow": '<button class="slick-prev-egypt slick-arrow" aria-label="Next" type="button" aria-disabled="false"><svg width="36" height="36" viewBox="0 0 36 36" class="fill-current text-primary" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_689_818)"><circle cx="18" cy="16" r="16" fill="white"/></g><path d="M12 28L28 16L12 4L12 8L23 16L12 24L12 28Z"/><defs><filter id="filter0_d_689_818" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_689_818"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_689_818" result="shape"/></filter></defs></svg></button>',
    "nextArrow": '<button class="slick-next-egypt slick-arrow" aria-label="Next" type="button" aria-disabled="false"><svg width="36" height="36" viewBox="0 0 36 36" class="fill-current text-primary" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_689_818)"><circle cx="18" cy="16" r="16" fill="white"/></g><path d="M12 28L28 16L12 4L12 8L23 16L12 24L12 28Z"/><defs><filter id="filter0_d_689_818" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_689_818"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_689_818" result="shape"/></filter></defs></svg></button>',
    "dots": false,
    "infinite": true,
    "arrows": true,
    "speed": 500,
    "slidesToShow": 3,
    "slidesToScroll": 3,
    "initialSlide": 0,
    responsive: [
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

  // Start Trim Selector JS
  jQuery('.div-colors-container').not('.slick-initialized').slick({
    "prevArrow": '<button class="slick-prev-egypt slick-arrow" aria-label="Next" type="button" aria-disabled="false"><svg width="36" height="36" viewBox="0 0 36 36" class="fill-current text-primary" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_689_818)"><circle cx="18" cy="16" r="16" fill="white"/></g><path d="M12 28L28 16L12 4L12 8L23 16L12 24L12 28Z"/><defs><filter id="filter0_d_689_818" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_689_818"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_689_818" result="shape"/></filter></defs></svg></button>',
    "nextArrow": '<button class="slick-next-egypt slick-arrow" aria-label="Next" type="button" aria-disabled="false"><svg width="36" height="36" viewBox="0 0 36 36" class="fill-current text-primary" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_689_818)"><circle cx="18" cy="16" r="16" fill="white"/></g><path d="M12 28L28 16L12 4L12 8L23 16L12 24L12 28Z"/><defs><filter id="filter0_d_689_818" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_689_818"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_689_818" result="shape"/></filter></defs></svg></button>',
    "dots": false,
    "infinite": true,
    "arrows": true,
    "speed": 500,
    "slidesToShow": 3,
    "slidesToScroll": 3,
    "initialSlide": 0,
    "responsive": [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

  // Start Explore More Vehicles JS
  jQuery('.explore-more-vehicles__models').not('.slick-initialized').slick({
    "prevArrow": '<button class="slick-prev-egypt slick-arrow" aria-label="Next" type="button" aria-disabled="false"><svg width="36" height="36" viewBox="0 0 36 36" class="fill-current text-primary" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_689_818)"><circle cx="18" cy="16" r="16" fill="white"/></g><path d="M12 28L28 16L12 4L12 8L23 16L12 24L12 28Z"/><defs><filter id="filter0_d_689_818" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_689_818"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_689_818" result="shape"/></filter></defs></svg></button>',
    "nextArrow": '<button class="slick-next-egypt slick-arrow" aria-label="Next" type="button" aria-disabled="false"><svg width="36" height="36" viewBox="0 0 36 36" class="fill-current text-primary" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d_689_818)"><circle cx="18" cy="16" r="16" fill="white"/></g><path d="M12 28L28 16L12 4L12 8L23 16L12 24L12 28Z"/><defs><filter id="filter0_d_689_818" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="2"/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_689_818"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_689_818" result="shape"/></filter></defs></svg></button>',
    "dots": false,
    "infinite": true,
    "speed": 500,
    "slidesToShow": 3,
    "slidesToScroll": 3,
    "initialSlide": 0,
    responsive: [
      {
        breakpoint: 1536,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
          breakpoint: 1280,
          settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  let siteUrl = window.location.pathname.replace('/new/', '').replace('/', '');
  let trimSelectorLink = document.querySelectorAll('.trim-selector__link')

  trimSelectorLink.forEach(url => {
    if (url.getAttribute('data-trim-url') === siteUrl) {
        const ele = url.querySelector('.trim-selector__item__trim-text');
        if (ele) {
            ele.classList.add('font-bold');
        }
    }
  });
 
  // End Trim Selector JS
  
  // // Start Calculator JS
  // // Get Selectors
  // let termSelector = document.querySelectorAll('.payment-calculator__term-selector');
  // termSelector.forEach(btn => {
  //   btn.addEventListener('click', () => {
  //       // Styles For Terms Selectors
  //       termSelector.forEach(btn => {
  //         btn.classList.add('bg-white', 'text-dark', 'shadow-[0px_2px_2px_rgba(0,0,0,0.1)]');
  //         btn.classList.remove('bg-primary', 'text-white');
  //       })

  //       btn.classList.add('bg-primary', 'text-white');
  //       btn.classList.remove('bg-white', 'text-dark', 'shadow-[0px_2px_2px_rgba(0,0,0,0.1)]');

  //       changeTaxAndLicLabel(btn);
  //   });
  // });

  // const changeTaxAndLicLabel = (btn) => {
  //   let taxAndLicLabel = document.querySelectorAll('#tax_and_lic_label');
  //   taxAndLicLabel.forEach(p => {
  //     p.innerHTML = `${btn.textContent.trim()} ${srpCalculator_ajax_object.tax_and_lic_label}`;
  //   });
  // }
  
  // let inputNumber = document.querySelectorAll('.payment-calculator__input');
  // inputNumber.forEach(input => {
  //   input.addEventListener('input', () => {
  //     calculateTotal(input);
  //     calculateFinanceAndLeaseTotal();
  //   });
  // });

  // const calculateDownPayment = (inputValue) => {
  //   let provinceTax = srpCalculator_ajax_object.province_tax_value;
  //   let provinceTaxValue = provinceTax ? (1 + (provinceTax / 100)) : 1.13;
  //   return inputValue / provinceTaxValue;
  // }

  // const calculateTotal = (inputItems) => {
  //   let sum = 0;
  //   let inputs = inputItems.closest('.payment-calculator__inputs-container').querySelectorAll('input.payment-calculator__input');
    
  //   inputs.forEach(input => {
  //     if(!isNaN(input.value) && input.value.length != 0) {
  //       input.name === 'trade-in-value' ? sum += parseFloat(input.value) : sum += calculateDownPayment(Number(input.value));
  //     }
  //   });
    
  //   let dataValue = Number(document.querySelectorAll('.payment-calculator__cash-value')[0].getAttribute('data-value'));
  //   let totalAmount = Math.floor(dataValue - sum);
  //   let totalAmountFormatted = totalAmount.toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
  //   document.querySelectorAll('.payment-calculator__cash-value')[0].textContent = totalAmountFormatted;
  // }

  // const getFinanceTotal = (price, rate, term, type) => {
  //   let total = Math.round( (price * (rate / 1200) * Math.pow(1 + (rate / 1200), term)) / ( Math.pow(1 + (rate / 1200), term) -1 ) * 100 ) / 100;
  //   total = Math.round(total, 2 );
  //   if (type === 'weekly' || type === null) {
  //     total = Math.floor(((total * 12) / 52))
  //   } else if (type === 'bi-weekly') {
  //     total = Math.floor(((total * 12) / 26))
  //   } else {
  //     total = total;
  //   }
  //   return total;
  // }

  // const getLeaseTotal = (price, term, rate, residual, type) => {
  //   let total = 0;
  //   let moneyFactor = (rate / 2400);
  //   let newResidual = price * (residual / 100);
  //   let depretiation = (price - (price * (residual / 100)) ) / term;
  //   let financeFee = (price + newResidual) * moneyFactor;
  //   let monthlyLease = financeFee + depretiation;

  //   if (type === 'weekly' || type === null) {
  //     total = Math.round((monthlyLease * 12) / 52);
  //   } else if (type === 'bi-weekly') {
  //     total = Math.round((monthlyLease * 12) / 26);
  //   } else {
  //     total = Math.round(monthlyLease);
  //   }
  //   return total;
  // }

  // let price = Number(document.querySelectorAll('.payment-calculator__cash-value')[0].textContent.replace('$', '').replace(',', ''));
  // let financeRate = Number(document.querySelectorAll('.payment-calculator__finance-rate')[0].textContent.replace('%', ''));
  // let financeTerm = Number(document.getElementById('finance-months').value);
  
  // if(getFinanceTotal(price, financeRate, financeTerm, 'weekly').toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 }) === '$NaN' || getFinanceTotal(price, financeRate, financeTerm, 'weekly').toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 }) === '$∞') {
  //   document.querySelectorAll('.payment-calculator__finance-value')[0].textContent = '$-';
  // } else {
  //   document.querySelectorAll('.payment-calculator__finance-value')[0].textContent = getFinanceTotal(price, financeRate, financeTerm, 'weekly').toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
  // }

  // let residual = Number(document.getElementById('lease-residual').value);
  // let leaseRate = Number(document.querySelectorAll('.payment-calculator__lease-rate')[0].textContent.replace('%', ''));
  // let leaseTerm = Number(document.getElementById('lease-months').value);

  // if(getLeaseTotal(price, leaseTerm, leaseRate, residual, 'weekly').toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 }) === '$NaN' || getLeaseTotal(price, leaseTerm, leaseRate, residual, 'weekly').toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 }) === '$∞') {
  //   document.querySelectorAll('.payment-calculator__lease-value')[0].textContent = '$-';
  // } else {
  //   document.querySelectorAll('.payment-calculator__lease-value')[0].textContent = getLeaseTotal(price, leaseTerm, leaseRate, residual, 'weekly').toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
  // }

  // let termSelectorListener = document.querySelectorAll('.payment-calculator__term-selector');

  // termSelectorListener.forEach(btn => {
  //   btn.addEventListener('click', () => {
  //     let price = Number(document.querySelectorAll('.payment-calculator__cash-value')[0].textContent.replace('$', '').replace(',', ''));
  //     let financeRate = Number(document.querySelectorAll('.payment-calculator__finance-rate')[0].textContent.replace('%', ''));
  //     let financeTerm = Number(document.getElementById('finance-months').value);
  
    
  //     let residual = Number(document.getElementById('lease-residual').value);
  //     let leaseRate = Number(document.querySelectorAll('.payment-calculator__lease-rate')[0].textContent.replace('%', ''));
  //     let leaseTerm = Number(document.getElementById('lease-months').value);

      
  //     if (btn.classList.contains('bg-primary') && btn.textContent.trim().toLowerCase() === 'weekly') {
  //       document.querySelectorAll('.payment-calculator__finance-value')[0].textContent = getFinanceTotal(price, financeRate, financeTerm, 'weekly').toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 });

  //       document.querySelectorAll('.payment-calculator__lease-value')[0].textContent = getLeaseTotal(price, leaseTerm, leaseRate, residual, 'weekly').toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
  //     } else if (btn.classList.contains('bg-primary') && btn.textContent.trim().toLowerCase() === 'bi-weekly') {
  //       document.querySelectorAll('.payment-calculator__finance-value')[0].textContent = getFinanceTotal(price, financeRate, financeTerm, 'bi-weekly').toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 });

  //       document.querySelectorAll('.payment-calculator__lease-value')[0].textContent = getLeaseTotal(price, leaseTerm, leaseRate, residual, 'bi-weekly').toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
  //     } else if (btn.classList.contains('bg-primary') && btn.textContent.trim().toLowerCase() === 'monthly') {
  //       document.querySelectorAll('.payment-calculator__finance-value')[0].textContent = getFinanceTotal(price, financeRate, financeTerm, 'monthly').toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 });

  //       document.querySelectorAll('.payment-calculator__lease-value')[0].textContent = getLeaseTotal(price, leaseTerm, leaseRate, residual, 'monthly').toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
  //     } else {
  //       return null;
  //     }
  //   });
  // });
  

  // const calculateFinanceAndLeaseTotal = () => {
  //   let termSelector = document.querySelectorAll('.payment-calculator__term-selector');
  //   let price = Number(document.querySelectorAll('.payment-calculator__cash-value')[0].textContent.replace('$', '').replace(',', ''));
  //   let financeRate = Number(document.querySelectorAll('.payment-calculator__finance-rate')[0].textContent.replace('%', ''));
  //   let financeTerm = Number(document.getElementById('finance-months').value);
    
  //   let residual = Number(document.getElementById('lease-residual').value);
  //   let leaseRate = Number(document.querySelectorAll('.payment-calculator__lease-rate')[0].textContent.replace('%', ''));
  //   let leaseTerm = Number(document.getElementById('lease-months').value);

  //   termSelector.forEach(btn => {
  //     if (btn.classList.contains('bg-primary') && btn.textContent.trim().toLowerCase() === 'weekly') {
  //       document.querySelectorAll('.payment-calculator__finance-value')[0].textContent = getFinanceTotal(price, financeRate, financeTerm, 'weekly').toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 });

  //       document.querySelectorAll('.payment-calculator__lease-value')[0].textContent = getLeaseTotal(price, leaseTerm, leaseRate, residual, 'weekly').toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
  //     } else if (btn.classList.contains('bg-primary') && btn.textContent.trim().toLowerCase() === 'bi-weekly') {
  //       document.querySelectorAll('.payment-calculator__finance-value')[0].textContent = getFinanceTotal(price, financeRate, financeTerm, 'bi-weekly').toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 });

  //       document.querySelectorAll('.payment-calculator__lease-value')[0].textContent = getLeaseTotal(price, leaseTerm, leaseRate, residual, 'bi-weekly').toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
  //     } else if (btn.classList.contains('bg-primary') && btn.textContent.trim().toLowerCase() === 'monthly') {
  //       document.querySelectorAll('.payment-calculator__finance-value')[0].textContent = getFinanceTotal(price, financeRate, financeTerm, 'monthly').toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 });

  //       document.querySelectorAll('.payment-calculator__lease-value')[0].textContent = getLeaseTotal(price, leaseTerm, leaseRate, residual, 'monthly').toLocaleString('en-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
  //     } else {
  //       return null;
  //     }
  //   });
  // }

  // let trimFinanceOffers = srpCalculator_ajax_object.trim_finance_offers;
  // let trimLeaseOffers = srpCalculator_ajax_object.trim_lease_offers;

  // const updateFinanceOffers = () => {
  //   let financeMonthsSelector = document.getElementById('finance-months');
  //   let financeRate = document.querySelectorAll('.payment-calculator__finance-rate')[0];

  //   trimFinanceOffers.forEach(offer => {
  //     if (offer.term === Number(financeMonthsSelector.value)) {
  //       financeRate.textContent = offer.rate;
  //       calculateFinanceAndLeaseTotal();
  //     }
  //   });
  // }
  
  // const updateLeaseOffers = () => {
  //   let leaseMonthsSelector = document.getElementById('lease-months');
  //   let leaseRate = document.querySelectorAll('.payment-calculator__lease-rate')[0];

  //   trimLeaseOffers.forEach(offer => {
  //     if (offer.term === Number(leaseMonthsSelector.value)) {
  //       leaseRate.textContent = offer.rate;
  //       document.getElementById('lease-residual').value = offer.residual;
  //       calculateFinanceAndLeaseTotal();
  //     }
  //   });
  // }
  
  // if (trimFinanceOffers && trimFinanceOffers.length > 0) {
  //   let financeMonthsSelector = document.getElementById('finance-months');
  //   financeMonthsSelector.addEventListener('change', () => {
  //     updateFinanceOffers();
  //   });
  //   updateFinanceOffers();
  // }

  // if (trimLeaseOffers && trimLeaseOffers.length > 0) {
  //   let leaseMonthsSelector = document.getElementById('lease-months');
  //   leaseMonthsSelector.addEventListener('change', () => {
  //     updateLeaseOffers();
  //   });
  //   updateLeaseOffers();
  // }
  // // End Calculator JS


  // MODEL CTA MODAL FORM
  function setExtraField(searchValue, classToAdd) {

    const hiddenFields = document.querySelectorAll('form input[type="hidden"]');
    hiddenFields.forEach(field => {
        if (field.value.toLowerCase() === searchValue.toLowerCase()) {
          field.classList.add(classToAdd);
        }
    });
  }

    const modalIds = document.querySelectorAll(".open-form");
    modalIds.forEach(mybutton => {
      
      const modalId = mybutton.getAttribute("data-id");      
      
      mybutton.addEventListener('click', () => {
        const modal = document.querySelector(`.form-${modalId}`);
        if (modal) {

          // adding extra data to hidden fields.
          let leadInfo='Model: ';

          let year = document.querySelector('.value__year');  
          let make = document.querySelector('.value__make');  
          let model = document.querySelector('.value__model');  
          let trim = document.querySelector('.trim__title');  

          leadInfo+= year.innerText + ' ' + make.innerText + ' ' + model.innerText + ' ' + trim.innerText;


          var extraFieldModelName = document.querySelector(`.form-${modalId} form .extraData-modelName`);
          if (extraFieldModelName) {
            extraFieldModelName.value = leadInfo;
            if (window.nfRadio) {
              nfRadio.channel('forms').trigger('change:field', extraField, leadInfo);
            }
            var event = new Event('change', { bubbles: true });
            extraFieldModelName.dispatchEvent(event);
          }
          
          
          leadInfo+=' -- Extradata: ';

          let condition = document.querySelectorAll('.value__condition');  
          condition.forEach(lbl => {
            leadInfo+='Condition: ' + lbl.innerText + ' ';
          });

          const btnColors = document.querySelectorAll('.round-color.active');
          let color = jQuery(btnColors[0]).parent('span');
          color = color[0];
          leadInfo+='- Color: ' + color.getAttribute('data-colorname') + ' ';

          const leadFrequency = document.querySelectorAll('.leadFrequency'); 
          let frequency = "";
          leadFrequency.forEach(freq=>{
            if(freq.classList.contains('weekly')) frequency = 'Weekly';
            if(freq.classList.contains('bi-weekly')) frequency = 'Bi-Weekly';
            if(freq.classList.contains('monthly')) frequency = 'Monthly';
          })

          if (frequency != '')
            leadInfo+='- Frequency: ' + frequency + ' ';

          const leadData = document.querySelectorAll('.infoLead');
          leadData.forEach(inpt => {
            leadInfo += `- ${inpt.getAttribute('data-key')}: ` + `${inpt.value}` + ' ';
          })

          const leadLabels = document.querySelectorAll('.labelLead');
          leadLabels.forEach(lbl => {
            leadInfo+=`- ${lbl.getAttribute('data-key')}: ` + `${lbl.innerText}` + ' ';
          })

          const leadCheck = document.querySelectorAll('.checkLead');
          leadCheck.forEach(chk=>{
            leadInfo+=`- ${chk.getAttribute('data-key')}: ` + ((chk.checked)?'true':'false') + ' ';
          })

         
          var extraField = document.querySelector(`.form-${modalId} form .extraData`);
          if (extraField) {
            extraField.value = leadInfo;
            if (window.nfRadio) {
              nfRadio.channel('forms').trigger('change:field', extraField, leadInfo);
            }
            var event = new Event('change', { bubbles: true });
            extraField.dispatchEvent(event);
          }
          // revealing form
          modal.classList.remove('hidden');
          modal.classList.add('flex');
        }
      });

      const closeBtn = document.querySelector(`.close-form-${modalId}`);
      closeBtn.addEventListener('click', () => {
        if (closeBtn) {
          const modal = document.querySelector(`.form-${modalId}`);
          if (modal) {
            modal.classList.remove('flex');
            modal.classList.add('hidden');
          }
        }
        
      });

      var continueBrowsingButton = document.querySelector(".lbx-continue-browsing-" + modalId);
      if (continueBrowsingButton) {
        continueBrowsingButton.addEventListener('click' , function() {
          //reiniciar el form 
          // Obtener el valor del atributo data-target
          var formID = this.getAttribute('data-target');

          // Resetear el formulario usando el ID
          var formContainer = document.querySelector('#nf-form-' + formID + '-cont form');

          if (formContainer) {
              formContainer.reset(); // Resetear el formulario
              formContainer.style.display = 'block';
          }

          var formMessage = document.querySelector('#nf-form-' + formID + '-cont .nf-response-msg'); 
          if (formMessage) {
            formMessage.style.display = 'none';
          }
          
          jQuery('.fsd-' + modalId).addClass('hidden');
          jQuery('.cta-continue-browsing.cb-' + modalId).removeClass('flex');
          jQuery('.cta-continue-browsing.cb-' + modalId).addClass('hidden');
          

          // cerrar el form
          
          const modal = document.querySelector(`.form-${modalId}`);
          if (modal) {
            modal.classList.remove('flex');
            modal.classList.add('hidden');
          }
            
        });
      }


    }); 

    //Adding extra fields to forms. 
    setTimeout(() => {

      setExtraField('extraData', 'extraData');
      setExtraField('ModelName', 'extraData-modelName');

    }, 500);

  // Evento cuando el formulario se envía con éxito
  jQuery(document).on('nfFormSubmitResponse', function(event, formData) {
      // Obtenemos el nombre del formulario
      var formName = formData.response.data.settings.title;
      // Transformamos el nombre del formulario: minúsculas y reemplazamos espacios por guiones
      var transformedFormName = formName.toLowerCase().replace(/\s+/g, '-');

      jQuery('.fsd-' + transformedFormName).removeClass('hidden');
      jQuery('.cta-continue-browsing.cb-' + transformedFormName).removeClass('hidden');
      jQuery('.cta-continue-browsing.cb-' + transformedFormName).addClass('flex');

      // track GA
      if (formName == '') {
        formName = 'form title not set';
      }
      let year = document.querySelector('.value__year');  
      let make = document.querySelector('.value__make');  
      let model = document.querySelector('.value__model');  
      let trim = document.querySelector('.trim__title'); 
      var label = formName+"-"+year+"-"+make+"-"+model+"-"+trim;
      var payLoad = { 
        'event_category': 'LBX-Form',
        'event_label': label
      };
      window.sendGAEvent('LBX-Submit', payLoad);

      if (window.fbq && typeof(fbq) === 'function') { 
        fbq('track', 'Lead'); }     
  });
});


